/**
 * Chat tool result field length defaults — keep in sync with
 * cascade-node-server/services/chatToolResultTextPaging.js
 */
export const CHAT_TOOL_RESULT_MAX_FIELD_LENGTH_DEFAULT = 100000;
export const CHAT_TOOL_RESULT_MAX_FIELD_LENGTH_MIN = 1000;
/** Users may raise well above the default (same hard max as text_limit). */
export const CHAT_TOOL_RESULT_MAX_FIELD_LENGTH_MAX = 1000000;
